var render, staticRenderFns
import script from "./ThgImpactSelectorRetire.vue?vue&type=script&lang=ts"
export * from "./ThgImpactSelectorRetire.vue?vue&type=script&lang=ts"
import style0 from "./ThgImpactSelectorRetire.vue?vue&type=style&index=0&id=406315a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406315a5",
  null
  
)

export default component.exports